import React from 'react'
import { component_tool, utils_tool } from '@/tool'
const { WizComponent, WizRow, WizCol, WizCheckbox, WizInput, WizTooltip } = component_tool;
const { checkStrLength } = utils_tool
export default class QsCheckbox extends WizComponent {
    render() {
        const { preview, answer, otherAnswer, allowOther, otherDescribe, options } = this.props
        const checkboxArr = options.map(val => <div key={val.id} style={{ marginBottom: 10 }}><WizCheckbox key={val.id} value={val.id}>{val.content}</WizCheckbox></div>)
        const CustomInput = () => {
            let inputProps = {}
            let checkboxProps = {}
            if (!preview) {
                inputProps = { ...inputProps, value: otherAnswer, disabled: true }
                checkboxProps = { ...checkboxProps, checked: true, disabled: true }
            }
            return (
                <WizRow type="flex" align="middle">
                    <WizCol span={8}>
                        <WizCheckbox {...inputProps}>
                            <WizTooltip title={otherDescribe}>{checkStrLength(otherDescribe, 10)}</WizTooltip>
                        </WizCheckbox>
                    </WizCol>
                    <WizCol pull={2} span={10}><WizInput {...checkboxProps} /></WizCol>
                </WizRow>
            )
        }

        let checkboxGroupProps = {}

        if (!preview) {
            checkboxGroupProps = { ...checkboxGroupProps, value: answer, disabled: true }
        }

        return (
            <>
                <WizCheckbox.Group {...checkboxGroupProps}>
                    {checkboxArr}
                </WizCheckbox.Group>
                {allowOther ? <CustomInput /> : null}
            </>
        )
    }
}
